



















































































import Vue, { PropType } from 'vue';
import Component, { mixins } from 'vue-class-component';

import { config } from './config';
import { locales } from './locales';

import { customizable, Options } from '../../mixins/customizable';
import { Eventable } from '../../mixins/eventable';
import { WarningRules } from '../../mixins/warningRules';

import { DateLogic } from './mixins/dateLogic';
import { MaskValue } from './mixins/maskValue';
import { Birthdate } from './mixins/birthdate';
import { PickerDate } from './mixins/pickerDate';
import { ErrorProp } from './mixins/errorProp';

import { mdiCalendar } from '@mdi/js';

import deepMerge from 'deepmerge';

const Props = Vue.extend({
	props: {
		noCalendar: {
			type: Boolean,
			default: false
		},
		noPrependIcon: {
			type: Boolean,
			default: false
		},
		outlined: {
			type: Boolean,
			default: false
		},
		appendIcon: {
			type: Boolean,
			default: false
		},
		textFieldActivator: {
			type: Boolean,
			default: false
		},
		textFieldClass: {
			type: [String, Array] as PropType<string | string[]>,
			default: undefined
		}
	}
});

const MixinsDeclaration = mixins(
	Props,
	customizable(config),
	Eventable,
	WarningRules,
	DateLogic,
	MaskValue,
	Birthdate,
	PickerDate,
	ErrorProp
);

@Component<DatePicker>({
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'change'
	}
})
export default class DatePicker extends MixinsDeclaration {
	locales = locales;

	calendarIcon = mdiCalendar;

	menu = false;

	get showPrependIcon(): boolean {
		return !this.noPrependIcon && !this.showAppendIcon;
	}

	get showAppendIcon(): boolean {
		return this.appendIcon || this.outlined;
	}

	get menuOptions(): Options {
		const position: Options = {
			nudgeBottom: this.outlined ? 56 : 45,
			nudgeRight: this.outlined ? 0 : 45
		};

		return deepMerge<Options>(position, this.options.menu);
	}

	get textFieldOptions(): Options {
		return deepMerge<Options>(this.options.textField, this.$attrs);
	}

	get textFieldClasses(): (string | string[])[] {
		const textFieldClasses = [];

		if (this.warningRules.length) {
			textFieldClasses.push('vd-warning-rules');
		}

		if (!this.showPrependIcon) {
			textFieldClasses.push('vd-no-prepend-icon');
		}

		if (this.textFieldClass) {
			const classes = typeof this.textFieldClass === 'object' ? this.textFieldClass : [this.textFieldClass];

			textFieldClasses.push(classes);
		}

		return textFieldClasses;
	}

	textFieldClicked(): void {
		if (this.textFieldActivator) {
			this.menu = true;
		}
	}
}
